import axiosInstance from "../../utils/axiosInstance";

// loading
import {
  setOpportunities,
  setOpportunnity,
  setLoading,
} from "../../store/slices/opportunity";
import { AppDispatch } from "../../store/store";
import { isAxiosError } from "axios";
import { notify } from "../../components/alerts";
import {
  IOpportunitiesResponse,
  IOpportunityDetailResponse,
} from "../../store/@types/opportunity";

const oppportunitiesEndpoint = "/product/api/v1/opportunities";

export const get_opportunities = async (
  dispatch: AppDispatch,
  limit: number,
  offset: number,
) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<IOpportunitiesResponse>(
      `${oppportunitiesEndpoint}`,
      {
        params: { limit, offset },
      },
    );
    dispatch(setOpportunities(response.data));
  } catch (err) {
    if (isAxiosError(err)) {
      notify({
        type: "error",
        message: err.response?.data.message || "Failed to load opportunity",
      });
    }
  }
  dispatch(setLoading(false));
};

export const get_opporunity = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoading(true));
  try {
    const response = await axiosInstance.get<IOpportunityDetailResponse>(
      `${oppportunitiesEndpoint}/${id}`,
    );
    dispatch(setOpportunnity(response.data.data));
  } catch (err) {
    if (isAxiosError(err)) {
      notify({
        type: "error",
        message: err.response?.data.message || "Failed to load opportunity",
      });
    }
  }
  dispatch(setLoading(false));
};
